<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Icon } from '@iconify/vue';
import { languageOptions } from '@/layouts/data/headerConfig';

const { locale } = useI18n();

const currentFlag = computed(() => {
  return (
    languageOptions.find((option) => option.code === locale.value)?.flagIcon ??
    'twemoji:flag-france'
  );
});

function changeLanguage(code: string) {
  locale.value = code;
}
</script>

<template>
  <v-menu
    open-on-hover
    open-on-click
  >
    <template #activator="{ props }">
      <v-btn
        icon
        variant="text"
        size="small"
        class="custom-hover-primary"
        v-bind="props"
      >
        <Icon
          :icon="currentFlag"
          height="22"
        />
      </v-btn>
    </template>

    <v-sheet
      rounded="md"
      width="240"
      elevation="10"
    >
      <v-list dense>
        <v-list-item
          v-for="option in languageOptions"
          :key="option.code"
          class="d-flex align-center"
          :active="locale === option.code"
          @click="changeLanguage(option.code)"
        >
          <template #prepend>
            <v-avatar size="24">
              <Icon
                :icon="option.flagIcon"
                height="20"
              />
            </v-avatar>
          </template>
          <v-list-item-title>
            {{ option.label }}
            <span class="text-caption text-disabled pl-2">({{ option.subtext }})</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-sheet>
  </v-menu>
</template>

<style lang="scss" scoped>
.custom-hover-primary {
  &:hover {
    background-color: rgb(var(--v-theme-lightprimary));
    color: rgb(var(--v-theme-primary));
  }
}
</style>
